const Data = [
  {
    "id": 1,
    "year": 2005,
    "goalnumber": 1,
    "for": "Hawthorn",
    "against": "Richmond",
    "game": "Round 2, 2005",
    "heading": "“This is number one”",
    "copy": "The first time Franklin put the ball between the big sticks at AFL level. After taking a mark on the lead Franklin was given a 50m free kick following a push from Richmond’s Mark Graham and he slotted it through for his first major in the big league."
  },
  {
    "id": 2,
    "year": 2005,
    "goalnumber": 2,
    "for": "Hawthorn",
    "against": "Richmond",
    "game": "Round 2, 2005",
    "heading": "“Emerging from the gloom”",
    "copy": "Franklin’s second goal at AFL level showed just what the talented Hawk was capable of. After the ball was knocked down, the key forward crumbed like a rover and with that magic left foot, kicked the goal from an angle."
  },
  {
    "id": 3,
    "year": 2016,
    "goalnumber": 764,
    "for": "Sydney",
    "against": "Carlton",
    "game": "Round 18, 2016",
    "heading": "“Is there anyone better than this man?”",
    "copy": "After Sam Naismith took a strong mark, he handballed it off to Franklin who led the Carlton defenders on a merry dance. Sam Docherty and then Jacob Weitering were made to look like they were stuck in sand at the SCG as Franklin danced around them and after a one-two handball he booted it through from outside 50."
  },
  {
    "id": 4,
    "year": 2007,
    "goalnumber": 120,
    "for": "Hawthorn",
    "against": "Adelaide",
    "game": "Elimination Final, 2007",
    "heading": "“What an inspiration”",
    "copy": "A moment where Franklin cemented his status as a superstar of the game. Down by three points with seconds to go against the Crows in the elimination final Franklin first got separation to take a mark and from outside 50 kicked his seventh to win the game for the Hawks."
  },
  {
    "id": 5,
    "year": 2008,
    "goalnumber": 211,
    "for": "Hawthorn",
    "against": "Brisbane Lions",
    "game": "Round 19, 2008",
    "heading": "“He has done the impossible”",
    "copy": "Brisbane’s Colm Begley and then Rhan Hooper would have been sure they were going to ping Franklin for holding the ball as he looked for his sixth goal in Launceston. But Franklin span out of the double tackle and despite the angle being against him showed his brilliance with his sixth major."
  },
  {
    "id": 6,
    "year": 2008,
    "goalnumber": 225,
    "for": "Hawthorn",
    "against": "Carlton",
    "game": "Round 22, 2008",
    "heading": "“People power has spoken”",
    "copy": "Cyril Rioli chips the ball over to an open Franklin late in the first quarter of Round 22 against Carlton. Franklin goes back and takes the set shot from 20m out on a slight angle, kicking his 100th goal of the season and causing the crowd at Docklands to go absolutely nuts, run onto the field and celebrate."
  },
  {
    "id": 7,
    "year": 2008,
    "goalnumber": 233,
    "for": "Hawthorn",
    "against": "Western Bulldogs",
    "game": "QF 2008",
    "heading": "“Buddy, you beauty”",
    "copy": "Pushed to ground 45m out during the second quarter, Franklin bounces back to his feet and pressures Bulldogs defender Brian Lake to steal the ball from him. Franklin evades another Bulldogs opponent and spins around on his left foot to slot a bouncing goal from 40m out."
  },
  {
    "id": 8,
    "year": 2008,
    "goalnumber": 231,
    "for": "Hawthorn",
    "against": "Western Bulldogs",
    "game": "QF 2008",
    "heading": "“That is a miracle goal. He’s extraordinary”",
    "copy": "Franklin holds off Bulldogs defender Brian Lake in a marking contest on a half-forward flank during the last quarter and gathers the loose ball after neither player can mark it in the air. Franklin quickly spins around and kicks the goal on the run on the 50m logo, despite continued pressure from Lake."
  },
  {
    "id": 9,
    "year": 2009,
    "goalnumber": 290,
    "for": "Hawthorn",
    "against": "Geelong",
    "game": "Round 17, 2009",
    "heading": "“Is there anything the man can’t do?”",
    "copy": "Campbell Brown handballs off to Franklin, who is running along the boundary line in the left forward pocket. Noticing an open goal square ahead, Franklin dribbles through a goal. The ball bounces straight over the goal umpire’s hat."
  },
  {
    "id": 10,
    "year": 2010,
    "goalnumber": 334,
    "for": "Hawthorn",
    "against": "Essendon",
    "game": "Round 13, 2010",
    "heading": "“Four goals to Buddy Franklin, and that’s probably the pick of them”",
    "copy": "Early in the last quarter, Franklin runs onto a loose ball on centre wing that has been handballed to him from teammate Jordan Lewis. Mark McVeigh gives chase but can’t keep up as Franklin runs to the 50m arc and kicks on his left, bouncing the ball through an open goal square."
  },
  {
    "id": 11,
    "year": 2010,
    "goalnumber": 335,
    "for": "Hawthorn",
    "against": "Essendon",
    "game": "Round 13, 2010",
    "heading": "“That’s as good a goal I’ve ever seen.”",
    "copy": "Legend says former Bomber Cale Hooker is still trying to catch Buddy on the wing of the MCG’s Olympic Stand. Arguably Buddy’s best and most remembered goal, the then Hawk gathered the ball on the wing, took three bounces along the boundary line and kicked truly on a tight angle. All while leaving poor Hooker in his wake."
  },
  {
    "id": 12,
    "year": 2011,
    "goalnumber": 451,
    "for": "Hawthorn",
    "against": "Collingwood",
    "game": "Preliminary final, 2011",
    "heading": "“He’s kicked a miracle!”",
    "copy": "One of Buddy’s most spectacular all-time goals on a huge stage. Running at full-tilt with a very quick Chris Tarrant right on his hammer, Franklin gathered at speed and kicked a brilliant dribbler goal with the outside of his left boot when deep in the pocket. It put the Hawks back in front deep in the final term before a late goal from Luke Ball sealed the win for Collingwood."
  },
  {
    "id": 13,
    "year": 2012,
    "goalnumber": 478,
    "for": "Hawthorn",
    "against": "North Melbourne",
    "game": "Round 10, 2012",
    "heading": "“Sometimes you’ve just got to sit back and enjoy the show!”",
    "copy": "What a day out this was for Buddy. With one minute to go in this one against North Melbourne in Launceston, Franklin brought up his 12th goal for the day with a great goal on the run on his trusty left boot from the pocket. That was special, but better was still to come that day just seconds later."
  },
  {
    "id": 14,
    "year": 2012,
    "goalnumber": 476,
    "for": "Hawthorn",
    "against": "North Melbourne",
    "game": "Round 10, 2012",
    "heading": "“Thirteen? THIRTEEN! Can you believe it?”",
    "copy": "Like Mike Williamson with his iconic “Jesaulenko, you beauty” commentary line when former Carlton great Alex Jesaulenko took a screamer in the 1970 VFL grand final, Fox Footy’s Anthony Hudson will always be best known for his brilliant call when Franklin snapped his 13th goal in the last three seconds against North Melbourne in 2012."
  },
  {
    "id": 15,
    "year": 2012,
    "goalnumber": 520,
    "for": "Hawthorn",
    "against": "Sydney",
    "game": "Grand Final, 2012",
    "heading": "“Franklin wheels around. Has it got the carry? I think so!”",
    "copy": "A quintessential, trademark Buddy goal on the biggest stage. A mark from outside the 50m before wheeling around and almost casually drilling a long goal on his left boot. He was still a Hawk this day, playing against his future club in the Swans. Despite Franklin’s brilliance, the Swans prevailed after an epic duel."
  },
  {
    "id": 16,
    "year": 2013,
    "goalnumber": 531,
    "for": "Hawthorn",
    "against": "Collingwood",
    "game": "Round 3, 2013",
    "heading": "“It’s a MCG special from Buddy”",
    "copy": "Moving like a gazelle, Franklin was all class as he first hurdled Hawks teammate Ben Stratton as he was brought down and not even breaking stride he kicked the ball from well within the centre square towards goal. Despite the distance the ball took just one bounce to goal."
  },
  {
    "id": 17,
    "year": 2014,
    "goalnumber": 608,
    "for": "Sydney",
    "against": "Port Adelaide",
    "game": "Round 13, 2014",
    "heading": "“Give him a longer contract”",
    "copy": "After marking the ball 70m away from goal and teammates in the forward 50 most players would wait for reinforcements to come. But Franklin isn’t like most players as he stepped back and with no run-up kicked the goal from the incredible distance."
  },
  {
    "id": 18,
    "year": 2014,
    "goalnumber": 609,
    "for": "Sydney",
    "against": "Port Adelaide",
    "game": "Round 13, 2014",
    "heading": "“He’s unstoppable”",
    "copy": "Alipate Carlile would have been happy where he had Franklin after spoiling the Swans’ stars marking contest, at the 50m arch away from goal and with Power defenders around him. But Franklin burst away from the three Port defenders and created brilliance out of nothing."
  },
  {
    "id": 19,
    "year": 2016,
    "goalnumber": 741,
    "for": "Sydney",
    "against": "Hawthorn",
    "game": "Round 9, 2016",
    "heading": "“You beauty Buddy”",
    "copy": "Hawks fans have cheered plenty when Franklin decides to go big from well over 50m. But at the MCG it was their time to groan as the Swan was left in space in the centre square and decided to go for home from 80m."
  },
  {
    "id": 20,
    "year": 2017,
    "goalnumber": 824,
    "for": "Sydney",
    "against": "Melbourne",
    "game": "Round 15, 2017",
    "heading": "“Only Buddy could do something like that”",
    "copy": "Franklin has kicked plenty of goals through brute power but against the Dees it was through poise. In the right place at the right time after Neville Jetta’s spoil inadvertently put the ball in his hands Franklin’s dribble kick from the right pocket was the stuff of brilliance."
  },
  {
    "id": 21,
    "year": 2017,
    "goalnumber": 846,
    "for": "Sydney",
    "against": "Adelaide",
    "game": "Round 22, 2017",
    "heading": "“Dennis where are you”",
    "copy": "Streaming down the Adelaide Oval wing with ball in hand, Franklin left Crows defender Daniel Talia in his dust and despite the angle being against him kicked the goal from the left pocket in a homage to one of his most iconic majors."
  },
  {
    "id": 22,
    "year": 2018,
    "goalnumber": 873,
    "for": "Sydney",
    "against": "Greater Western Sydney",
    "game": "Round 3, 2018",
    "heading": "“This is Buddy Franklin, this is the greatest showman”",
    "copy": "Surrounded by Giants, Franklin issued a don’t argue to GWS defender Nick Haynes, turned and well from outside 50 kicked the goal to show why the Swans offered him the contract they did."
  },
  {
    "id": 23,
    "year": 2021,
    "goalnumber": 990,
    "for": "Sydney",
    "against": "Gold Coast",
    "game": "Round 23, 2021",
    "heading": "“Buddy has gone bang in the opening 10 seconds”",
    "copy": "It took Franklin just seconds to make his mark in the final home and away game against the Suns. After marking the ball following a Swans clearance, Franklin played on immediately and after taking a couple of strides he let fly from outside 50 for a blistering start."
  }
 ]

export default Data


// WEBPACK FOOTER //
// ./src/components/Data.js